(function() {
  function initQuantityCm() {
    document.querySelectorAll('[data-quantity-cm]').forEach(function(block) {
      if (block.dataset.quantityCmInitialized) return;
      block.dataset.quantityCmInitialized = 'true';
      var step = parseInt(block.dataset.step, 10) || 10;
      var min = parseInt(block.dataset.min, 10) || 10;
      var max = parseInt(block.dataset.max, 10) || 850;
      var valueInput = block.querySelector('[data-quantity-cm-input]');
      var displayInput = block.querySelector('[data-quantity-cm-value]');
      var fill = block.querySelector('[data-quantity-cm-fill]');
      var label = block.querySelector('[data-quantity-cm-label]');
      var minusBtn = block.querySelector('[data-quantity-cm-minus]');
      var plusBtn = block.querySelector('[data-quantity-cm-plus]');
      var form = block.querySelector('form.quantity-cm-form');
      var priceEl = block.querySelector('[data-quantity-cm-price]');
      var comparePriceEl = block.querySelector('[data-quantity-cm-compare-price]');
      var sliderInput = block.querySelector('[data-quantity-cm-slider-input]');
      var unitPrice = parseInt(block.dataset.unitPrice, 10) || 0;
      var compareAtPrice = block.dataset.compareAtPrice ? parseInt(block.dataset.compareAtPrice, 10) : 0;

      function getVal() { return parseInt(displayInput.value, 10) || min; }
      function formatMoney(cents) {
        var amount = (cents / 100).toFixed(2).replace('.', ',');
        return (typeof window.KROWN !== 'undefined' && window.KROWN.settings && window.KROWN.settings.iso_code) ? amount + window.KROWN.settings.iso_code : amount + ' zł';
      }
      function setVal(v) {
        v = Math.max(min, Math.min(max, v));
        displayInput.value = v;
        if (valueInput) valueInput.value = v;
        if (fill) fill.style.width = (v * 100 / max) + '%';
        if (label) label.textContent = v + ' / ' + max + ' cm';
        if (minusBtn) minusBtn.disabled = v <= min;
        if (plusBtn) plusBtn.disabled = v >= max;
        if (priceEl && unitPrice) priceEl.textContent = formatMoney(unitPrice * v);
        if (comparePriceEl && compareAtPrice) comparePriceEl.textContent = formatMoney(compareAtPrice * v);
        if (sliderInput) sliderInput.value = v;
      }

      if (minusBtn) minusBtn.addEventListener('click', function() { setVal(getVal() - step); });
      if (plusBtn) plusBtn.addEventListener('click', function() { setVal(getVal() + step); });
      if (sliderInput) sliderInput.addEventListener('input', function() { setVal(parseInt(sliderInput.value, 10)); });
      setVal(getVal());

      if (form) {
        form.addEventListener('submit', function(e) {
          e.preventDefault();
          var submitBtn = form.querySelector('.quantity-cm-add-btn');
          if (submitBtn) submitBtn.classList.add('working');
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'application/json' },
            body: new URLSearchParams(new FormData(form))
          })
          .then(function(r) { return r.json().then(function(data) { return { ok: r.ok, data: data }; }); })
          .then(function(res) {
            if (submitBtn) submitBtn.classList.remove('working');
            if (!res.ok) {
              if (res.data && (res.data.description || res.data.message)) alert(res.data.description || res.data.message);
              return;
            }
            if (typeof window.refreshCart === 'function') window.refreshCart();
            else if (document.getElementById('site-cart-sidebar') && document.getElementById('site-cart-sidebar').show) document.getElementById('site-cart-sidebar').show();
            else window.location.href = '/cart';
          })
          .catch(function() {
            if (submitBtn) submitBtn.classList.remove('working');
            window.location.href = '/cart';
          });
        });
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initQuantityCm);
  } else {
    initQuantityCm();
  }
})();
